import { PROVINCES } from '@/organisation/constants';
import { capitalizeFirstLetter } from '@/common/utils/formatting';
import {
  EXCLUSIVE_RESPONSE_OPTIONS,
  isMultiChoice,
  isSingleChoice,
} from '@/common/services/items';
import VueI18n from '@/i18n';

export const CLICKABLE_STATUSES = [
  'draft',
  'submitted',
  'in_progress',
  'finished',
  'not_active',
];

const t = (key) => VueI18n.t(key);

export const getProvinces = (countryCode) => Object.keys(PROVINCES[countryCode])
  .map((key) => {
    const provinceArr = key
      .split('-')
      .map((provinceChunk) => (capitalizeFirstLetter(provinceChunk)));
    return {
      key,
      value: provinceArr.join('-'),
    };
  });


export const calculateFrequencies = (answers, researchItem) => {
  let allValues = [];
  if (isMultiChoice(researchItem.item.render_type)) {
    allValues = answers.map((answer) => answer.value_list).flat();
  }
  if (isSingleChoice(researchItem.item.render_type)) {
    allValues = answers.map((answer) => answer.value_str);
  }
  const { options } = researchItem.item;
  const optionsObject = options.reduce((acc, option) => {
    acc[option.value] = option.short_value || option.value;
    return acc;
  }, {});

  const exclusiveResponse = researchItem.item.config.exclusive_response;
  if (exclusiveResponse) {
    optionsObject[exclusiveResponse] = t(EXCLUSIVE_RESPONSE_OPTIONS[exclusiveResponse]);
  }

  allValues = allValues.filter((value) => value !== null && value !== '');
  const uniqueValues = [...new Set(allValues)];

  const frequencies = uniqueValues.map((option) => [
    optionsObject[option], (allValues.filter(
      (answer) => answer === option,
    ).length / answers.length) * 100,
  ]);

  if (researchItem.item.config.random) {
    return frequencies.sort((a, b) => b[1] - a[1]);
  }
  const frequenciesObject = Object.fromEntries(frequencies);
  return Object.values(optionsObject).map((option) => [
    option, frequenciesObject[option],
  ]).filter((optionsArray) => optionsArray[1] > 0);
};
